import React from "react";
import { MusicHallListContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import queryString from "query-string";
import { portalService } from "apiServices";
import momentTZ from "moment-timezone";
import { MdAdd } from "react-icons/md";
import * as XLSX from "xlsx";
import {
  BOOKING_STATUS,
  BOOKING_EVENT_STATUS,
  BOOKING_ADMIN_TASK,
  BOOKING_SOURCE,
  ROOM_TYPE_LIST,
  RENDER_ROOM_TYPE,
  RENDER_BOOKING_EVENT_STATUS,
  RENDER_BOOKING_STATUS,
  RENDER_BOOKING_SOURCE,
  RENDER_BOOKING_STATUS_COLOR,
  RENDER_BOOKING_STATUS_LABEL,
  RENDER_BOOKING_ADMIN_TASK,
} from "utils/functions/musicHall";
import moment from "moment";
import { ROUTE_PATH } from "utils/constants/routePath";
import { BookingStepWidget } from "widgets";
import { Buttons, Displays, Inputs, Tables } from "components";

// วันจัดงาน + เวลา รวมไว้ช่องเดียว ให้อ่านคู่กับ Alternative Date ได้ตรงรูปแบบ
// ห้องซ้อมไม่มีช่วงเตรียม/เก็บงาน (เก็บเป็น "00.00") จึงไม่ต้องแสดงบรรทัดนั้น
const EVENT_DATE_PARTS = (booking) => {
  const start = booking.setup_cleanup_start_time;
  const end = booking.setup_cleanup_end_time;
  const hasSetup = start && end && !(start === "00.00" && end === "00.00");
  return {
    dateLabel: momentTZ(booking.booking_date)
      .tz("Asia/Bangkok")
      .format("DD/MM/YYYY"),
    setupLabel: hasSetup ? `เตรียม ${start} - ${end}` : "",
    eventLabel: `จัดงาน ${booking.event_start_time} - ${booking.event_end_time}`,
  };
};

// วัน+เวลาแบบข้อความบรรทัดเดียว (ใช้กับ Excel ที่ขึ้นบรรทัดใหม่ในเซลล์ไม่ได้)
const EVENT_DATE_TEXT = (booking) => {
  const parts = EVENT_DATE_PARTS(booking);
  return [parts.dateLabel, parts.setupLabel, parts.eventLabel]
    .filter((e) => e)
    .join(" | ");
};

// วัน+เวลาแบบซ้อนบรรทัด ใช้ในตาราง ทั้งวันหลักและวันสำรองใช้ตัวเดียวกัน จะได้หน้าตาตรงกัน
const RENDER_DATE_BLOCK = (booking, key) => {
  const parts = EVENT_DATE_PARTS(booking);
  return (
    <div key={key}>
      <div>{parts.dateLabel}</div>
      {parts.setupLabel && <div>{parts.setupLabel}</div>}
      <div>{parts.eventLabel}</div>
    </div>
  );
};

// วันสำรองรูปแบบเก่าเก็บเป็นวันล้วน ไม่มี booking_date ข้างใน
// ถ้าไม่กรองออก moment(undefined) จะคืน "วันนี้" ทำให้โชว์วันที่ผิดเหมือนเป็นข้อมูลจริง
const VALID_ALTERNATIVE_DATES = (list) =>
  (list || []).filter((e) => e && e.booking_date);

// ห้องซ้อมมีหลายห้อง แสดงชื่อห้องจริง (เช่น M1 Grand Piano) แทนชื่อประเภท
// ถ้าข้อมูลเก่าไม่มีชื่อห้อง ใช้ชื่อประเภทแทน
const RENDER_ROOM_NAME = (booking) =>
  (booking.room_type === "2" && booking.room_name_th) ||
  RENDER_ROOM_TYPE(booking.room_type).labelTh;

const RENDER_ALTERNATIVE_DATE = (list) => {
  const items = VALID_ALTERNATIVE_DATES(list);
  if (items.length === 0) return "-";
  return items.map((e) => EVENT_DATE_TEXT(e)).join(" / ");
};

class MusicHallListContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    const query = this.buildQueryString();
    this.fetchData(query);
  }

  fetchData = async (query) => {
    let res = await portalService.GET_ROOM_BOOKING_LIST(query);
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  // QUERY FLOW
  // =========================================
  // =========================================
  buildQueryString = (additionalParams = {}) => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    const defaultQuery = {
      limit: 20,
      // start_date: moment().startOf("month").format("YYYY-MM-DD"),
      // end_date: moment().endOf("month").format("YYYY-MM-DD"),
    };
    const finalParams = {
      ...defaultQuery,
      ...urlParams,
      ...additionalParams,
    };
    const cleanParams = Object.entries(finalParams)
      .filter(
        ([key, value]) => value !== null && value !== undefined && value !== "",
      )
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    const query = `?${Object.entries(cleanParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&")}`;
    router.navigate(`${ROUTE_PATH.MUSIC_HALL_BOOKING_LIST}${query}`);
    return query;
  };
  handleFilterKeyword = (e) => {
    const queryParams =
      typeof e === "string" ? queryString.parse(e.replace("?", "")) : e;
    // InputFilter ไม่ส่ง key ที่เลือก All (ค่าว่าง) มาเลย ถ้าไม่ล้างเอง ค่าเก่าใน url จะค้าง
    // ล้างเฉพาะ filter แบบ text/dropdown ส่วน dateGroup ส่ง start_date=&end_date= มาเองตอนเลือก All
    // และไม่ส่งอะไรมาถ้าไม่ได้แตะ (ล้างเองจะทำให้ช่วงวันที่ที่เลือกไว้หาย)
    const clearedFilters = dataFilter("")
      .filter((f) => f.filter && f.filter.type !== "dateGroup")
      .reduce((acc, f) => ({ ...acc, [f.filter.fieldQuery]: "" }), {});
    // เปลี่ยน filter แล้วกลับหน้า 1 กันค้างหน้าที่ไม่มีข้อมูล
    this.handleJoinQuery({ ...clearedFilters, page: "", ...queryParams });
  };
  handlePageClick = (e) => {
    this.handleJoinQuery({ page: e.selected + 1 });
  };
  handlePerPageChange = (limit) => {
    this.handleJoinQuery({ limit, page: 1 });
  };
  handleJoinQuery = (additionalQuery) => {
    const query = this.buildQueryString(additionalQuery);
    this.setState({
      isLoading: true,
    });
    this.fetchData(query);
  };

  handleClickDetail = (e) => {
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL_BOOKING}/detail/${e._id}`,
    );
  };

  handleExport = async () => {
    let query = this.buildQueryString();
    query += `&pagination=false`;
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.GET_ROOM_BOOKING_LIST(query);
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";

      /* make worksheet */
      let ws_data = res.data.docs.reduce((result, e, i) => {
        let params1 = [
          i + 1,
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD-MM-YY"),
          e.booker_first_name,
          e.booker_last_name,
          e.booker_phone,
          RENDER_BOOKING_SOURCE(e.booking_source).labelEn,
          RENDER_ROOM_NAME(e),
          EVENT_DATE_TEXT(e),
          RENDER_ALTERNATIVE_DATE(e.alternative_booking_dates),
          RENDER_BOOKING_STATUS(e.status).labelEn,
          e.status === "5"
            ? RENDER_BOOKING_EVENT_STATUS(e.event_status).labelEn
            : RENDER_BOOKING_ADMIN_TASK(e.status)?.label || "-",
        ];
        result.push(params1);
        return result;
      }, []);
      let columnTemp = [
        {
          name: "No",
          wch: 4,
        },
        {
          name: "Create Date",
          wch: 16,
        },

        {
          name: "ชื่อ",
          wch: 25,
        },
        {
          name: "นามสกุล",
          wch: 25,
        },
        {
          name: "Phone",
          wch: 25,
        },
        {
          name: "Type",
          wch: 25,
        },
        {
          name: "Room",
          wch: 25,
        },
        {
          name: "Event Date",
          wch: 46,
        },
        {
          name: "Alternative Date",
          wch: 30,
        },
        {
          name: "Booking Status",
          wch: 20,
        },
        {
          name: "Action/Event Status",
          wch: 20,
        },
      ];
      /* make worksheet */
      ws_data.splice(
        0,
        0,
        columnTemp.map((e) => e.name),
      );
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let wscols = columnTemp.map((e) => {
        return { wch: e.wch };
      });
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `music-hall-practice-${moment()
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY")}.xlsx`,
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.MUSIC_HALL_BOOKING}/${e}`);
  };

  render() {
    const { router, authenRedux } = this.props;
    const { isBgLoading, isLoading, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find(
          (e) => e.menu_key === "music-hall-booking",
        );
    return (
      <MusicHallListContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="title">Music Hall & Room Booking</div>
        {permission && permission.is_create && (
          <div className="btn_create">
            <Buttons.BgIconPrefix
              label="New Booking"
              icon={<MdAdd size={18} />}
              onClick={() => this.handleClickCreate("create")}
            />
          </div>
        )}
        <div className="filter_layout">
          <Inputs.InputFilter
            theme_standard_input_filter
            dataFilter={dataFilter(router.location?.search)}
            btnLabel="ค้นหา"
            onQueryFilter={this.handleFilterKeyword}
            onExport={
              permission &&
              (permission.is_export || permission.is_export_condition)
                ? () => this.handleExport(permission)
                : false
            }
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <Tables.Standard
            columns={columns()}
            data={data.docs}
            showPagination
            pagination={{
              last_page: data.totalPages,
              current_page: data.page,
              total: data.totalDocs,
              per_page: data.limit,
            }}
            handlePageClick={this.handlePageClick}
            onChangePerPage={this.handlePerPageChange}
            onRowClick={this.handleClickDetail}
          />
        )}
      </MusicHallListContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "name",
      length: "311px",
      filter: {
        fieldQuery: "name",
        defaultValue: initialValues["name"],
        type: "text",
        label: "Name",
        placeholder: "Name",
      },
    },
    {
      accessor: "phone",
      length: "311px",
      filter: {
        fieldQuery: "phone",
        defaultValue: initialValues["phone"],
        type: "text",
        label: "Phone Number",
        placeholder: "Phone Number",
      },
    },
    {
      accessor: "room_type",
      length: "311px",
      filter: {
        fieldQuery: "room_type",
        defaultValue: initialValues["room_type"],
        type: "dropdown",
        label: "Room",
        placeholder: "All",
        options: [{ label: "All", value: "" }, ...ROOM_TYPE_LIST],
      },
    },
    {
      accessor: "booking_source",
      length: "311px",
      filter: {
        fieldQuery: "booking_source",
        defaultValue: initialValues["booking_source"],
        type: "dropdown",
        label: "Type",
        placeholder: "All",
        options: [{ label: "All", value: "" }, ...BOOKING_SOURCE],
      },
    },
    {
      accessor: "status",
      length: "311px",
      filter: {
        fieldQuery: "status",
        defaultValue: initialValues["status"],
        type: "dropdown",
        label: "Status",
        placeholder: "All",
        options: [{ label: "All", value: "" }, ...BOOKING_STATUS],
      },
    },
    {
      accessor: "event_status",
      length: "311px",
      filter: {
        fieldQuery: "event_status",
        defaultValue: initialValues["event_status"],
        type: "dropdown",
        label: "Action/Event Status",
        placeholder: "All",
        // ห้ามใส่ BOOKING_ADMIN_TASK ลง BOOKING_EVENT_STATUS ตรง ๆ เพราะฟอร์มเปลี่ยน event status ใช้ list นั้นด้วย
        options: [
          { label: "All", value: "" },
          ...BOOKING_EVENT_STATUS,
          ...BOOKING_ADMIN_TASK.map(({ label, value }) => ({ label, value })),
        ],
      },
    },
    {
      accessor: "group_by",
      filter: {
        label: "Time Period",
        fieldQuery: "group_by",
        type: "dateGroup",
        initialValues: {
          level1: !initialValues["group_by"]
            ? "all"
            : initialValues["group_by"],
          level2:
            initialValues["group_by"] === "date_range"
              ? {
                  startDate: new Date(initialValues["start_date"]),
                  endDate: new Date(initialValues["end_date"]),
                }
              : false,
        },
        options: [
          { label: "All", value: "all" },
          { label: "วันนี้", value: "today" },
          { label: "เดือนนี้", value: "this_month" },
          { label: "เดือนหน้า", value: "next_month" },
          { label: "ช่วงเวลา", value: "date_range" },
        ],
      },
    },
  ];
};

const columns = () => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) =>
      momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY"),
  },
  {
    Header: (
      <div style={{ textAlign: "left" }}>
        Booking Status
        <BookingStepWidget theme_table currentStep={0}/>
      </div>
    ),
    accessor: "status",
    Cell: (props) => {
      const statusColor = RENDER_BOOKING_STATUS_COLOR(props.value);
      return (
        <Displays.StatusLabel
          txtColor={statusColor.txtColor}
          bg={statusColor.bgColor}
          label={RENDER_BOOKING_STATUS_LABEL(props.value)}
        />
      );
    },
  },
  {
    Header: <div style={{ textAlign: "left" }}>Action/Event Status</div>,
    accessor: "event_status",
    Cell: (props) => {
      if (props.row.original.status !== "5") {
        const adminTask = RENDER_BOOKING_ADMIN_TASK(props.row.original.status);
        return adminTask ? (
          <Displays.StatusLabel
            txtColor={adminTask.txtColor}
            bg={adminTask.bgColor}
            label={adminTask.label}
          />
        ) : (
          "-"
        );
      } else {
        const renderStatus = RENDER_BOOKING_EVENT_STATUS(props.value);
        return (
          <Displays.StatusLabel
            txtColor={renderStatus.txtColor}
            bg={renderStatus.bgColor}
            label={renderStatus.labelEn}
          />
        );
      }
    },
  },
  {
    Header: <div style={{ textAlign: "left" }}>ชื่อ</div>,
    accessor: "booker_first_name",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>นามสกุล</div>,
    accessor: "booker_last_name",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Phone Number</div>,
    accessor: "booker_phone",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Type</div>,
    accessor: "booking_source",
    Cell: (props) => RENDER_BOOKING_SOURCE(props.value).labelEn,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Room</div>,
    accessor: "room_type",
    Cell: (props) => RENDER_ROOM_NAME(props.row.original),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Event Date</div>,
    accessor: "booking_date",
    Cell: (props) => RENDER_DATE_BLOCK(props.row.original),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Alternative Date</div>,
    accessor: "alternative_booking_dates",
    Cell: (props) => {
      const items = VALID_ALTERNATIVE_DATES(props.value);
      if (items.length === 0) return "-";
      return (
        <div className="date_block_group">
          {items.map((e, i) => RENDER_DATE_BLOCK(e, i))}
        </div>
      );
    },
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(MusicHallListContainer));
